<template>
    <div class="tab-container">
        <div
            :class="['tab-item', { active: selectedTab && selectedTab.name == tab.name }]"
            @click="handleTabChange(tab)"
            v-for="tab of tabs"
            :key="tab.name"
        >
            <div>{{ tab.value }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        selectedTab: {
            type: Object,
            default: null,
        },
        tabs: {
            // array of objects with name and value properties
            type: Array,
            default: () => [],
        },
    },
    mounted() {
        const tab = this.$route.query.active_tab
        if (tab) {
            this.$emit(
                "change",
                this.tabs.find((item) => item.name == tab)
            )
        }
    },
    methods: {
        handleTabChange(tab) {
            this.$emit("change", tab)
            const url = this.$router.resolve({
                ...this.$route,
                query: {
                    ...this.$route.query,
                    active_tab: tab.name,
                },
            }).href
            console.log("the full url is", url)
            console.log("active tab is", tab)
            this.$router.push(url)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.tab-container {
    display: flex;
    gap: 4px;
    margin-bottom: 20px;
    border-bottom: 2px solid $gray100;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.tab-item {
    cursor: pointer;
    padding: 10px 20px;
    text-align: center;
    font-size: 13px;
    font-weight: 500;
    color: $gray500;
    border-bottom: 2px solid transparent;
    margin-bottom: -2px;
    white-space: nowrap;
    transition: all $transitionFast;
    border-radius: $radiusSm $radiusSm 0 0;

    &:hover:not(.active) {
        color: $gray700;
        background: $gray50;
    }

    &.active {
        color: $primaryColor;
        border-bottom-color: $primaryColor;
        font-weight: 600;
        background: $primaryLight;
    }
}

@media (max-width: 480px) {
    .tab-item {
        padding: 10px 14px;
        font-size: 12px;
        min-width: 0;
    }
}
</style>
